"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSelectAllButton = exports.StyledProductsBulkActionsPanelActions = exports.StyledProductsBulkActionsPanelContent = exports.StyledProductsBulkActionsPanel = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledProductsBulkActionsPanel = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
  z-index: 1;
`;
exports.StyledProductsBulkActionsPanelContent = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
`;
exports.StyledProductsBulkActionsPanelActions = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.StyledSelectAllButton = (0, styled_components_1.default)(ui_components_1.Button) `
  flex-shrink: 0;
`;
